<mlp-ng-icon name="custom-spinner-solid" animation="spin"></mlp-ng-icon>
